import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { InfoPanelMode } from "../../Panels/CMFileInfoPanel";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";

export function useMenuItem_Properties(selectedItems: any[], setIsCMFileInfoPanelOpen: (isCMFileInfoPanelOpen: boolean) => void, setInfoPanelMode: (infoPanelMode: InfoPanelMode) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);

  const [menuItem_Properties, setMenuItem_Properties] = React.useState<IContextualMenuItem>();
  const [menuItem_Properties_IconOnly, setMenuItem_Properties_IconOnly] = React.useState<IContextualMenuItem>();

  const checkForFolders = () => {
    const containsInvalidContentId = selectedItems?.some(item => {
      return (
        (item.ContentTypeId && item.ContentTypeId.startsWith(SharePointFolderContentTypeIds.folder) && !item.ContentTypeId.startsWith(SharePointFolderContentTypeIds.documentSet)) ||
        (item.EffectiveBasePermission && item.EffectiveBasePermission.canEditListItem === false)
      )
    });
    if (containsInvalidContentId) {
      return false;
    } else {
      return true;
    }
  }

  React.useEffect(() => {
    if (selectedItems.length > 0 && checkForFolders()) {
      setMenuItem_Properties_IconOnly(
        {
          key: "info",
          disabled: isBusySaving === true,
          iconProps: { iconName: "Info" },
          iconOnly: true,
          tooltipHostProps: {
            content: <span>{languageStrings.Properties}</span>
          },
          onClick: () => {
            setInfoPanelMode(InfoPanelMode.Update)
            setIsCMFileInfoPanelOpen(true);
          }
        }
      );

      setMenuItem_Properties(
        {
          key: "properties",
          text: languageStrings.Properties,
          iconProps: { iconName: "Info" },
          onClick: () => {
            setInfoPanelMode(InfoPanelMode.Update)
            setIsCMFileInfoPanelOpen(true);
          }
        }
      );
    } else {
      setMenuItem_Properties_IconOnly(null);
      setMenuItem_Properties(null);
    }
  }, [selectedItems]);

  return {
    menuItem_Properties,
    menuItem_Properties_IconOnly
  }
}